import { render } from "./CreditorsPage.vue?vue&type=template&id=dcb2613a&scoped=true"
import script from "./CreditorsPage.vue?vue&type=script&lang=js"
export * from "./CreditorsPage.vue?vue&type=script&lang=js"

import "./CreditorsPage.vue?vue&type=style&index=0&id=dcb2613a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\abbas\\Desktop\\kswc\\kswc_dashboard-main\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dcb2613a"]])

export default __exports__